import Model from './Model'

export default class Product extends Model {
  resource()
  {
    return 'products'
  }

  toFilterOptions(models) {
    if (!Array.isArray(models)) return [];
    return models.map(model => ({
      value: String(model.id),
      label: `${model.brand.name} - ${model.name}${model.reference ? ` (${model.reference})` : ''}${model.year ? ` (${model.year})` : ''}`,
    }));
  }
}